import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/AlertDialog';

export type MonitorActionType = 'reread' | 'category';

export interface PendingAction {
  type: MonitorActionType;
  catalogIds: number[];
}

const COPY: Record<MonitorActionType, { title: string; description: string }> =
  {
    reread: {
      title: 'Re-read in Vision?',
      description:
        'The Vision result is discarded and the product(s) go back through the reading pipeline (status back to pending, attempts reset, SEO marked pending).',
    },
    category: {
      title: 'Regenerate Vision category name?',
      description:
        'The category status goes back to pending and the category name is classified again. Only products that are in stock and active, from customers with category updates on, are picked up.',
    },
  };

interface ActionConfirmDialogProps {
  action: PendingAction | null;
  onCancel: () => void;
  onConfirm: (action: PendingAction) => void;
}

export function ActionConfirmDialog({
  action,
  onCancel,
  onConfirm,
}: ActionConfirmDialogProps) {
  const copy = action ? COPY[action.type] : undefined;

  return (
    <AlertDialog open={!!action} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{copy?.title}</AlertDialogTitle>
          <AlertDialogDescription>
            {copy?.description}
            {action && (
              <span className="mt-2 block font-medium">
                Affects {action.catalogIds.length} catalog row(s).
              </span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={() => action && onConfirm(action)}>
            Confirm
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
